export default [
    {
      path: '/information',
      name: 'information',
      component: () => import('@/views/sft/Information.vue'),
    },
  ]